import React from 'react';
import { ComponentTypes } from 'logi-embed/types';
import { LogiComponent } from '../LogiComponent';
import { InventoryItemTypes } from 'logi-embed/EmbeddedInventory';
/**
 * Renders a LogiInventoryDashboard component.
 * This component is responsible for rendering the Dashboard's inventory of Logi Composer.

 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.configuration - The configuration object.
 * @param {Function} props.getToken - The function to get the token.
 * @param {string} props.logiBaseUrl - The base URL for Logi Composer.
 * @param {string} props.inventoryStyleWidth - The width style for the visual builder.
 * @param {string} props.inventoryStyleHeight - The height style for the visual builder.
 * @example
 * ```tsx
 * <LogiInventoryDashboard
 *   configuration={...}
 *   getToken={...}
 *   logiBaseUrl={...}
 *   inventoryStyleWidth={...}
 *   inventoryStyleHeight={...}
 * />
 * ```
 */
export const LogiInventoryDashboard = ({ configuration, getToken, logiBaseUrl, inventoryStyleWidth, inventoryStyleHeight, }) => {
    return (React.createElement(LogiComponent, { componentType: ComponentTypes.INVENTORY, configuration: Object.assign(Object.assign({}, configuration), { inventoryItem: InventoryItemTypes.DASHBOARD }), getToken: getToken, logiBaseUrl: logiBaseUrl, styleWidth: inventoryStyleWidth, styleHeight: inventoryStyleHeight, ariaLabel: 'Logi Inventory Dashboard' }));
};
